(function () {
  var footerSelector = '.nv-footer';
  var navColumnSelector = '.nv-footer__nav-col';
  var mobileQuery = window.matchMedia('(max-width: 699px)');

  function setColumnState(column, isOpen, isMobile) {
    var toggle = column.querySelector('.nv-footer__nav-toggle');
    var panel = column.querySelector('.nv-footer__nav-panel');

    if (!toggle || !panel) return;

    column.classList.toggle('is-open', isOpen);
    toggle.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
    toggle.disabled = !isMobile;
    panel.hidden = isMobile && !isOpen;
  }

  function setupFooterAccordion(footer) {
    var columns = Array.prototype.slice.call(footer.querySelectorAll(navColumnSelector));
    var isMobile = mobileQuery.matches;

    columns.forEach(function (column) {
      var toggle = column.querySelector('.nv-footer__nav-toggle');

      if (!toggle) return;

      if (!toggle.dataset.nvAccordionReady) {
        toggle.dataset.nvAccordionReady = 'true';

        toggle.addEventListener('click', function () {
          if (!mobileQuery.matches) return;

          var shouldOpen = toggle.getAttribute('aria-expanded') !== 'true';

          columns.forEach(function (item) {
            setColumnState(item, false, true);
          });

          setColumnState(column, shouldOpen, true);
        });
      }

      setColumnState(column, isMobile ? column.dataset.nvFooterDefaultOpen === 'true' : true, isMobile);
    });
  }

  function setupAllFooters() {
    document.querySelectorAll(footerSelector).forEach(setupFooterAccordion);
  }

  document.addEventListener('DOMContentLoaded', setupAllFooters);
  document.addEventListener('shopify:section:load', setupAllFooters);

  if (mobileQuery.addEventListener) {
    mobileQuery.addEventListener('change', setupAllFooters);
  } else if (mobileQuery.addListener) {
    mobileQuery.addListener(setupAllFooters);
  }
})();
